<!-- Просмотр записи -->
<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" :stroke="stroke"
    stroke-width="2" aria-hidden="true" focusable="false">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
</template>
<script>
export default {
  name: "EyeIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
